<template>
  <div class="overlay">
    <div class="modal-container" :style="customStyle">
      <div class="modal-header" :style="customHeaderStyle">
        {{ title }}
        <img src="@/assets/images/cancel.png" class="close-icon" alt="close" @click="onCancel" />
      </div>
      <div class="modal-content" :style="contentStyle">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <span class="error-message">{{ error && `Error: ${error}` }}</span>
        <div class="modal-footer">
          <div class="cancel-button" @click="onCancel">
            Cancel
          </div>
          <custom-button
            customStyle="width: 120px; height: 35px; font-size: 14px;"
            :onClick="onSave"
            :disabled="disabled"
          >
            Save
          </custom-button>
        </div>
      </div>
      <div v-if="saving" class="loading">
        <Circle2 />
      </div>
    </div>
  </div>
</template>

<script>
import { Circle2 } from './vue-loading-spinner/src';
import CustomButton from '@/components/CustomButton';

export default {
  name: 'CustomModal',
  components: { CustomButton, Circle2 },
  props: {
    onSave: Function,
    onCancel: Function,
    title: String,
    customStyle: String,
    customHeaderStyle: String,
    contentStyle: String,
    disabled: Boolean,
    error: String,
    saving: Boolean
  }
};
</script>

<style scoped lang="scss">
.modal-container {
  position: relative;
  background-color: #ffffff;
  border: 1px solid #e8eaed;
  box-sizing: border-box;
  box-shadow: 0 4px 10px rgba(13, 29, 63, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .loading {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: hsla(0, 0%, 100%, 0.8);
  }

  .modal-header {
    height: 65px;
    background-color: #f4f5f7;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    font-weight: bold;
    font-size: 24px;
    line-height: 35px;
    letter-spacing: -0.04em;
    color: #374561;

    .close-icon {
      width: 25px;
      height: 25px;
      cursor: pointer;
    }
  }

  .modal-content {
    flex: 1;
  }

  .modal-footer {
    height: 70px;
    border-top: 1px solid #f4f5f7;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;

    .error-message {
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0.1px;
      color: $colorRed;
    }
    .cancel-button {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.01em;
      color: $colorPlaceholder;
      margin-right: 20px;
      cursor: pointer;
    }
  }
}
</style>
